import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Notification, NotificationListQuery, NotificationListResult } from '../models/notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/notifications`;

  getNotifications(query: NotificationListQuery = {}): Observable<NotificationListResult> {
    let params = new HttpParams();
    if (query.technicianId) params = params.set('technicianId', query.technicianId);
    if (query.isRead !== undefined) params = params.set('isRead', query.isRead);
    if (query.page) params = params.set('page', query.page);
    if (query.pageSize) params = params.set('pageSize', query.pageSize);

    return this.http.get<NotificationListResult>(this.baseUrl, { params });
  }

  markNotificationRead(notificationId: number): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/${notificationId}/read`, {});
  }
}
